import { render, staticRenderFns } from "./TextViewCellRenderer.vue?vue&type=template&id=4972f122&"
import script from "./TextViewCellRenderer.vue?vue&type=script&lang=js&"
export * from "./TextViewCellRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports